module.exports = __webpack_public_path__ + "static/media/expert3.790c3447.png";